const { cELM, getWindowHeight } = require("./utils");
const Scroller = require("./components/scroller");
const Block = require("./components/blocks/index");
const ProgressBar = require("./components/progress-bar");
const ScrollNotification = require("./components/scroll-notification");
const MedicationModule = require("./modules/medication-module");
const MedicationModulev15 = require("./modules/medication-module-v15");
const MedicationModulev20 = require("./modules/medication-module-v20");
const OcrModule = require("./modules/ocr-module");
const FileUploaderModule = require("./modules/file-uploader-module");
const ImageUploadModule = require("./modules/image-upload-module")
const InsuranceModule = require("./modules/insurance-module");
const InsuranceModuleV2 = require("./modules/insurance-module-v2");
const QuizModule = require("./modules/quiz-module");
const QuizLogicModule = require("./modules/quizlogic-module");
const CreditCardModule = require("./modules/credit-card-module");
const CreditCardContractModule = require("./modules/creditcard-contract-module");
const CopayModule = require("./modules/copay-module");
const PreviousBalanceModule = require('./modules/previousbalance-module');
const Popup = require("./components/popup");
const PharmacyModule = require('./modules/pharmacy-module');
const EmployerModule = require('./modules/employer-module');
const AllergiesModule = require('./modules/allergies-module');
const AllergiesV2Module = require('./modules/allergies-v2-module');
const SurgicalHistoryModule = require('./modules/surgical-history-module');
const PastMedicalHistoryModule = require('./modules/past-medical-history-module');
const CareTeamMemberModule = require('./modules/care-team-member-module');
const SchedulerModule = require('./modules/scheduler-module')
const ProviderDepartmentAppointmentTypeReasonsModule = require('./modules/provider-department-appointmenttype-reasons-module.js');
const Chat = require("./chat");

window.chnPop = Popup.chnPop;
window.confirmPop = Popup.confirmPop;

class Bot {
  constructor(containerClass) {
    this.elContainer = cELM("div", containerClass || "bot");
    this.contentHash = {};
    this.typingIndicator = new Block({
          data: {
            id:"thinking",
            sender: { id: "bot" },
            status: "typing",
            text: "",
            thinking: true

          }
        });

    this.elContainer.addELM(this.typingIndicator);
  }

  handleSchedulerModule(type, value) {
    if (value.format && value.format.startsWith("module_scheduler")) {
      if (value.values.format === "schedule-date") {
        this.typingIndicator = null;
        if ((value.values.dateSelectedBool || {}).bool) {
          // Do not ignore typing because date has been selected --> The patient has chosen a slot to book.
          this.ignoreTyping = false;
        } else {
          // Ignore typing during scheduler module, so that no "blinking" occurs when loading the slots.
          this.ignoreTyping = true;
        }
      }
      if (!value.values.invalidBookedTimeslotAttemptInitial && value.values.invalidBookedTimeslotAttempt === true) {
        const iModule = new SchedulerModule(type, value, this);
        this.elContainer.addELM(iModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, iModule];
        this.contentHash[value.id][1].handle(type, value);
      } else if (this.contentHash[value.id]) {
        this.contentHash[value.id][1].handle(type, value)
        return;
      } else {
        const iModule = new SchedulerModule(type, value, this);
        this.elContainer.addELM(iModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, iModule];
        this.contentHash[value.id][1].handle(type, value);
      }
      return true;
    };

    return false;
  }

  handleProviderDepartmentAppointmentTypeReasonsModules(type, value) {
    if (value.format && (value.format.startsWith("module_provider-select") || value.format.startsWith("module_department-select") || value.format.startsWith("module_reason-of-visit"))) {
      if (value.format.startsWith("module_reason-of-visit")) {
        value.values.values = value.values.appointmentReasonsTypes;
      } else if (value.format.startsWith("module_provider-select")) {
        value.values.values = value.values.providers;
      } else if (value.format.startsWith("module_department-select")) {
        value.values.values = value.values.departments;
      }
      if (this.contentHash[value.id]) {
        this.contentHash[value.id][1].handle(type, value)
      } else {
        const iModule = new ProviderDepartmentAppointmentTypeReasonsModule(type, value, this);
        this.elContainer.addELM(iModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, iModule];
        this.contentHash[value.id][1].handle(type, value);
      }
      return true;
    };

    return false;
  }

  handleMedicationModule(type, value) {
    // AR: Need to add new med module here _medsv15_ ?
    // pass all requests to medication module
    if (value && value.format && value.format.indexOf('module_meds_') > -1) { //AR need to support multiple languages
      if (this.contentHash[value.id]) {
        this.contentHash[value.id][1].handle(type, value);
      } else {
        const mModule = new MedicationModule(type, value);
        this.elContainer.addELM(mModule);
        mModule.scrollToFirstItem();

        this.contentHash[value.id] = [Object.keys(this.contentHash).length, mModule];
      }

      return true;
    } else if (value.format === 'module_medsv15_eng') {
      if (this.contentHash[value.id]) {
        this.contentHash[value.id][1].handle(type, value);
      } else {
        const mModule = new MedicationModulev15(type, value);
        this.elContainer.addELM(mModule);
        mModule.scrollToFirstItem();

        this.contentHash[value.id] = [Object.keys(this.contentHash).length, mModule];
        this.contentHash[value.id][1].handle(type, value);
      }

      return true;
    } else if (value.format === 'module_medsv20_eng') {

      this.ignoreTyping = (value.values || {}).format == 'medication-list';

      if (this.contentHash[value.id]) {

        this.contentHash[value.id][1].handle(type, value);
      } else {

        const mModule = new MedicationModulev20(type, value);
        this.elContainer.addELM(mModule);
        mModule.scrollToFirstItem();

        this.contentHash[value.id] = [Object.keys(this.contentHash).length, mModule];
        this.contentHash[value.id][1].handle(type, value);

        setTimeout(() => {
          this.showMore(mModule.getELM());
        }, 400);

      }

      //CA: For edit
      let contentHashId = this.contentHash[value.id][0];
      if (typeof contentHashId != "undefined") {
        const newHash = {};
        Object.keys(this.contentHash).forEach(key => {
          const ch = this.contentHash[key];
          if (ch[0] > contentHashId) {
            this.elContainer.removeELM(ch[1]);
          } else {
            newHash[key] = ch;
          }
        });
        this.contentHash = newHash;
      }

      return true;
    }
    window.__FN_DATA_WRAPPER = null;
    return false;
  }

  handleOcrModule(type, value) {
    // pass all request to uploader module
    if (
      [
        "scan-card",
        "card-back",
        "onfiletransfer-started",
        "onfiletransfer-uploading",
        "onfiletransfer-uploaded",
        "onfiletransfer-complete",
        "onfiletransfer-resized",
        "onfiletransfer-processed",
        "onfiletransfer-processed-validated",
      ].indexOf(value.format) > -1
    ) {

      var isMicrosoft = (function(){  // ie10, ie11, edge
        var ua = window.navigator.userAgent;
        var result = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1 || ua.indexOf('Edge/') > -1
        if (result) {
          value.text = 'Sorry. We just realize you are using an incompatible browser to upload';
          value.subtext = 'Don\'t worry. We can still get your information';
        }
        return result
      })()
      var component ;

      if (this.contentHash[value.id]) {
        this.contentHash[value.id][1].handle(value);
      } else if (this._lastUModule) {
        this._lastUModule.handle(value);
      } else {
        const uModule = new OcrModule(type, value);
        this.elContainer.addELM(uModule);
        uModule.scrollToElement();
        setTimeout(() => {
          this.showMore(uModule.getELM());
        }, 400);

        this.contentHash[value.id] = [Object.keys(this.contentHash).length, uModule];
        this._lastUModule = uModule;
      }
      component = (this.contentHash[value.id] || [])[1] || this._lastUModule
      if (isMicrosoft && component && (component.elements || {})._btnEl) {
        component.elements._btnEl.style.display = 'none'
      }
      return true;
    }

    this._lastUModule = null;
    return false;
  }

  handleFileUploaderModule(type, value) {
    // pass all request to uploader module
    if (
      [
        "file-uploader",
        "onfileupload-started",
        "onfileupload-uploading",
        "onfileupload-uploaded",
      ].indexOf(value.format) > -1
    ) {
      if (this.contentHash[value.id]) {
        this.contentHash[value.id][1].handle(value);
      } else if (this._lastFUModule) {
        this._lastFUModule.handle(value);
      } else {
        const fuModule = new FileUploaderModule(type, value);
        this.elContainer.addELM(fuModule);
        fuModule.scrollToElement();
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, fuModule];
        this._lastFUModule = fuModule;
      }
      return true;
    }

    this._lastFUModule = null;
    return false;
  }

  handleImageUploadModule(type,value){
  if (
      [
        "image-upload",
        "image-upload-insurance-front",
        "image-upload-insurance-back",
        "onimageupload-started",
        "onimageupload-uploading",
        "onimageupload-uploaded",
        "onimageupload-resized",
        "onimageupload-processed",
        "onimageupload-processed-validated",
      ].indexOf(value.format) > -1
    ) {
      if (this.contentHash[value.id]) {
        this.contentHash[value.id][1].handle(value);
      } else if (this._lastFUModule) {
        this._lastFUModule.handle(value);
      } else {
        const fuModule = new ImageUploadModule(type, value);
        this.elContainer.addELM(fuModule);
        fuModule.scrollToElement();
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, fuModule];
        this._lastFUModule = fuModule;
        this._lastFUModule.handle(value);
      }
      return true;
    }

    this._lastFUModule = null;
    return false;
  }

  handleInsuranceModule(type, value) {
    // pass all request to uploader module
    if (value.format && value.format.startsWith("module_insurancev2")) {
      if (!this.contentHash[value.id]) {
        const iModule = new InsuranceModuleV2(type, value, this);
        this.elContainer.addELM(iModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, iModule];
      }
      this.contentHash[value.id][1].handle(type, value);
      return true;
    } else if (value.format && value.format.startsWith("module_insurance")) {
      if (!this.contentHash[value.id]) {
        const iModule = new InsuranceModule(type, value, this);
        this.elContainer.addELM(iModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, iModule];
      }

      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }

  handleQuizModule(type, value) {
    // pass all request to uploader module
    if (value.format && value.format.startsWith("module_quiz_")) {
      if (!this.contentHash[value.id]) {
        const qModule = new QuizModule(type, value, this);
        this.elContainer.addELM(qModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, qModule];
      }
      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }

  handleQuizLogicModule(type, value) {
    if (value.values?.format === "image-upload") {
      return this.handleImageUploadModule(type, value.values);
    }
    // pass all request to uploader module
    if (value.format && (value.format.startsWith("module_quizlogic_") || value.format.startsWith("module_quizcms_") )) {
      if (!this.contentHash[value.id]) {
        const qlModule = new QuizLogicModule(type, value, this);
        this.elContainer.addELM(qlModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, qlModule];
      }
      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }


  handleCreditCardModule(type, value) {
    // pass all request to uploader module
    if (value.format && value.format.startsWith("module_creditcard-contract")) {
      if (!this.contentHash[value.id]) {
        const ccModule = new CreditCardContractModule(type, value, this);
        this.elContainer.addELM(ccModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, ccModule];
      }

      this.contentHash[value.id][1].handle(type, value);
      return true;
    } else if (value.format && value.format.startsWith("module_creditcard")) {
      if (!this.contentHash[value.id]) {
        const ccModule = new CreditCardModule(type, value, this);
        this.elContainer.addELM(ccModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, ccModule];
      }

      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }

  handleCopayModule(type, value) {
    // pass all request to uploader module
    if (value.format && value.format.startsWith("module_copay")) {
      if (!this.contentHash[value.id]) {
        const copayModule = new CopayModule(type, value, this);
        this.elContainer.addELM(copayModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, copayModule];
      }

      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }

  handlePreviousBalanceModule(type, value) {
    // pass all request to uploader module
    if (value.format && value.format.startsWith("module_previousbalance")) {
      if (!this.contentHash[value.id]) {
        const previousBalanceModule = new PreviousBalanceModule(type, value, this);
        this.elContainer.addELM(previousBalanceModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, previousBalanceModule];
      }

      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }

  handlePharmacyModule(type, value) {
    // pass all request to uploader module
    if (value.format && value.format.startsWith("module_pharmacy")) {
      if (!this.contentHash[value.id]) {
        const pharmacyModule = new PharmacyModule(type, value, this);
        this.elContainer.addELM(pharmacyModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, pharmacyModule];
      }

      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }

  handleEmployerModule(type, value) {
    // pass all request to uploader module
    if (value.format && value.format.startsWith("module_employer")) {
      if (!this.contentHash[value.id]) {
        const employerModule = new EmployerModule(type, value, this);
        this.elContainer.addELM(employerModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, employerModule];
      }

      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }

  handleAllergiesModule(type, value) {

    if(value.format && value.format.indexOf('module_allergy') > -1) {

      this.ignoreTyping = (value.values || {}).format == 'allergy-list';

      if (this.contentHash[value.id]) {

        this.contentHash[value.id][1].handle(type, value);
      } else {

        const mModule = value.format.includes('module_allergyv2') ? new AllergiesV2Module(type, value) : new AllergiesModule(type, value);
        this.elContainer.addELM(mModule);
        mModule.scrollToFirstItem();

        this.contentHash[value.id] = [Object.keys(this.contentHash).length, mModule];
        this.contentHash[value.id][1].handle(type, value);

        setTimeout(() => {
          this.showMore(mModule.getELM());
        }, 400);

      }

      let contentHashId = this.contentHash[value.id][0];
      if (typeof contentHashId != "undefined") {
        const newHash = {};
        Object.keys(this.contentHash).forEach(key => {
          const ch = this.contentHash[key];
          if (ch[0] > contentHashId) {
            this.elContainer.removeELM(ch[1]);
          } else {
            newHash[key] = ch;
          }
        });
        this.contentHash = newHash;
      }

      return true;
    }

    return false;
  }

  handleSurgicalHistoryModule(type, value) {
    if (value.format && value.format.startsWith("module_surgicalhistory")) {
      if (!this.contentHash[value.id]) {
        const surgicalModule = new SurgicalHistoryModule(type, value, this);
        this.elContainer.addELM(surgicalModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, surgicalModule];
      }

      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }


  handlePastMedicalHistoryModule(type, value) {
    if (value.format && value.format.startsWith("module_pastmedicalhistory")) {
      if (!this.contentHash[value.id]) {
        const pmModule = new PastMedicalHistoryModule(type, value, this);
        this.elContainer.addELM(pmModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, pmModule];
      }

      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }

  handleCareTeamMemberModule(type, value) {
    if (value.format && value.format.startsWith("module_careteammember")) {
      if (!this.contentHash[value.id]) {
        const careTeamModule = new CareTeamMemberModule(type, value, this);
        this.elContainer.addELM(careTeamModule);
        this.contentHash[value.id] = [Object.keys(this.contentHash).length, careTeamModule];
      }

      this.contentHash[value.id][1].handle(type, value);
      return true;
    }

    return false;
  }

  showTyping() {
    this.typingIndicator = new Block({
      data: {
        id:"thinking",
        sender: { id: "bot" },
        status: "typing",
        text: "",
        thinking: true
      }
    });

    this.elContainer.addELM(this.typingIndicator);
  }

  renderUnavailableSlotMessageAfterLockExpire(idSecondCalendar,secondaryAction="timeslotLockExpired") {
    const _self = this.elContainer;
    const noLongerAvailableBackground = cELM("div", "")
    noLongerAvailableBackground.id = 'no-longer-available-background';

    const noLongerAvailable = cELM("div", "");
    noLongerAvailable.id = 'no-longer-available';
    const flexTop = cELM("div", "");
    flexTop.id = 'no-longer-available-flex-top'
    const flexTopText = cELM("div", "");
    flexTopText.id = 'no-longer-available-flex-top-text';
    flexTopText.innerText = "Sorry that appointment time is no longer available.";
    flexTop.addELM(flexTopText);

    const flexBottom = cELM("div", "")
    flexBottom.id = 'no-longer-available-flex-bottom';
    const okButtonWrapper = cELM("div")
    okButtonWrapper.className = "option modal-button-wrapper"
    okButtonWrapper.id = 'no-longer-available-ok'; //**

    const okButton = cELM("div")
    okButton.className = "option-text modal-button"
    okButton.id = 'no-longer-available-ok-text'; //**
    okButton.innerText = "OK";
    okButtonWrapper.addELM(okButton);
    noLongerAvailable.addELM(flexTop);
    flexBottom.addELM(okButtonWrapper);
    noLongerAvailable.addELM(flexBottom)

    const hideUnavailableSlotMessage = () => {
      _self.removeELM(noLongerAvailableBackground);
      _self.removeELM(noLongerAvailable);

      const data = {
        id: idSecondCalendar,  // AB: Second Calendar component
        text: ""
      }
      Chat.default.customEdit(data, secondaryAction);
      this.showTyping();
    }

    noLongerAvailableBackground.onclick = hideUnavailableSlotMessage;
    okButton.onclick = hideUnavailableSlotMessage;

    _self.addELM(noLongerAvailableBackground);
    _self.addELM(noLongerAvailable)
  }

  removeEditBtn(node) {
    const editBtnParent = node[1]._element.childNodes[3];
    if (!editBtnParent) {
      return false;
    }
    const editBtn = editBtnParent.childNodes[1];
    if (editBtn) {
      editBtnParent.removeELM(editBtn);
    }
    return true;
  }

  handle(type, value, reference) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    if (value && value.action == "lockout" && value.format === "") {  // AB: When showing scheduling idle while booking complete message
      value.progress = 100;
    }

    if (value && value.values && value.values.invalidBookedTimeslotAttemptInitial === true) {
      this.renderUnavailableSlotMessageAfterLockExpire(value.values.idSecondCalendar,value.values.secondaryAction);  // AB: Display sorry for inconvenience message

      for (const key in this.contentHash) {
        const ch = this.contentHash[key];
        if (ch[1].contentHash) {  // AB: If is a module
          for (const key in ch[1].contentHash) {
            this.removeEditBtn(ch[1].contentHash[key]);
          }
        } else {  // AB: If is a normal non-module question
          this.removeEditBtn(ch);
        }
      }

    }

    if (value && value.action == "lockout") {
      for (const key in this.contentHash) {
        const ch = this.contentHash[key];
        this.elContainer.removeELM(ch[1]);
      }
      this.contentHash = {};
      const possibleAdditionalElems = this.elContainer.querySelectorAll(".scheduler-module");
      for (const elem of possibleAdditionalElems) {
        this.elContainer.removeELM(elem);
      }
    }

    if(value && value.status === 'typing') {
      this.elContainer.classList.add('typing');
    } else {
      this.elContainer.classList.remove('typing');
    }

    //CA: Question skipped from dashboard, need to remove all questions above
    //to avoid that the patient edit back and comes again to the skipped question
    if(value && value.skippedFromDashboard) {
      const keys = Object.keys(this.contentHash);

      if(keys && keys.length) {

        for(const k of keys) {
          const [ index, lastEl ] = this.contentHash[k];

          if(lastEl) {
            this.elContainer.removeELM(lastEl);
            delete this.contentHash[k];
          }
        }
      }
    }

    if (this.handleMedicationModule(type, value)) return false;
    if (this.handleAllergiesModule(type, value)) return false;
    if (this.handleOcrModule(type, value)) return false;
    if (this.handleFileUploaderModule(type, value)) return false;
    if (this.handleInsuranceModule(type, value)) return false;
    if (this.handleQuizModule(type, value)) return false;
    if (this.handleQuizLogicModule(type, value)) return false;
    if (this.handleCreditCardModule(type, value)) return false;
    if (this.handleSurgicalHistoryModule(type, value)) return false;
    if (this.handlePastMedicalHistoryModule(type, value)) return false;
    if (this.handleCareTeamMemberModule(type, value)) return false;
    if (this.handleSchedulerModule(type, value)) return false;
    if (this.handleProviderDepartmentAppointmentTypeReasonsModules(type, value)) return false;
    if (this.handleCopayModule(type, value) || this.handlePreviousBalanceModule(type, value)) {
      let contentHashId = this.contentHash[value.id][0];

      if (typeof contentHashId != "undefined") {
        const newHash = {};
        Object.keys(this.contentHash).forEach(key => {
          const ch = this.contentHash[key];
          if (ch[0] > contentHashId) {
            this.elContainer.removeELM(ch[1]);
          } else {
            newHash[key] = ch;
          }
        });
        this.contentHash = newHash;
      }

      return false;
    }
    if (this.handlePreviousBalanceModule(type, value)) return false;
    if (this.handleImageUploadModule(type, value)) return false;
    if (this.handlePharmacyModule(type, value)) return false;
    if (this.handleEmployerModule(type, value)) return false;

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }

    // AR: Custom CSS is added now - no need for this
    // todo: hard code banner. to be removed
    if (
      value.status !== "typing" &&
      Object.keys(this.contentHash).length === 0 &&
      window.hasHeader === true
    ) {
      const appRoot = document.getElementById("app-root");
      if (!this.header) {
        const _bannerEl = cELM("div", "header-image");
        const _bannerHeaderEl = cELM("div", "component-block header");
        _bannerHeaderEl.addELM(_bannerEl);

        this.header = _bannerEl;
        appRoot.insertBefore(_bannerHeaderEl, appRoot.firstChild);
      }
    }
    // end of hard code

    const _elm = this.handleOnMessage(value);

    // attach new question/answer elements
    if (!_elm) return;
    this.elContainer.addELM(_elm);

    // add show more button
    this.showMore(_elm.getELM());

    // scroll to element or bottom
    if (value.status !== "typing" && Object.keys(this.contentHash).length > 1) {
      Scroller.scrollToElm(_elm, () => {
        _elm.focus();
      });
    } else {
      setTimeout(() => {
        _elm.focus();
      }, 400);
    }
  }

  handleOnMessage(value) {
    if(value.id){
      let pts = value.id.split('/');
      if(pts.length > 1){
        window.CHATBOT_LANGUAGE = pts[2];
      }
    }

    let component = null;
    if (value.format === "empty") return null;

    // AR: we only want 1 instance of this question
    let identifier = value.id;
    if (identifier.endsWith("/error")) {
      identifier = identifier.split("/error")[0];
      this.elContainer.removeELM(this.contentHash[identifier][1]);
      this.contentHash[identifier] = null;
    }

    if (identifier.endsWith("/answer")) {
      identifier = identifier.split("/answer")[0];
      let question = this.contentHash[identifier][1];

      // AR: need to remove previous questions & answers
      const validYesAnsw = [ 'yes', 'si', 'sí' ];
      const isAnswerYes = (((value || {}).data || '').trim && validYesAnsw.indexOf(((value || {}).data || '').trim().toLowerCase())> -1);
      if ((value.dataFormat && value.dataFormat.indexOf("yes/no-back") > -1 && isAnswerYes) ||
        (value.dataFormat && value.dataFormat.indexOf("yes/back") > -1 && !isAnswerYes)) {
        let backBy = null;
        if (value.dataFormat.indexOf("yes/back") > -1) {
          backBy = parseInt(value.dataFormat.split("yes/back")[1] || "-1");
        }
        else {
          backBy = parseInt(value.dataFormat.split("yes/no-back")[1] || "-1");
        }

        for (let bkIdx = backBy; bkIdx <= 0; bkIdx++) {
          let idParts = identifier.split("/");
          idParts[3] = parseInt(idParts[3]) + bkIdx;

          let toRemoveIdentifier = idParts.join("/");

          if (this.contentHash[toRemoveIdentifier]) {
            this.elContainer.removeELM(this.contentHash[toRemoveIdentifier][1]);
            delete this.contentHash[toRemoveIdentifier];
          }
        }
        return;
      } else {
        question.updateAnswer(value, this.clearAfterId.bind(this));
      }
    }

    if(this.contentHash[identifier] && this.contentHash[identifier][1] && (value.format == 'info-card' || value.format == 'info-card-v2')){
      this.elContainer.removeELM(this.contentHash[identifier][1]);
      this.contentHash[identifier] = null;
    }

    if (
      !this.contentHash[identifier] ||
      value.format === "array" ||
      value.format === "medication" ||
      value.format === "search"
    ) {
      // handle suggestions for array-medication
      if (this.contentHash[identifier]) {
        if (value.values)
          this.contentHash[identifier][1]._option._element.updateSuggestions(
            value.values.suggestions,
          );
        return;
      }

      component = new Block({
        data: value,
      });

      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
      } else {
        this.contentHash[identifier] = [Object.keys(this.contentHash).length, component];
      }
    } else if (
        this.contentHash[identifier]
        && this.contentHash[identifier][1]
        && this.contentHash[identifier][1].value
        && this.contentHash[identifier][1].value.values
        && this.contentHash[identifier][1].value.values.format === "schedule-date"
        && this.contentHash[identifier][1].value.values.dateSelectedBool.bool === false
      )
    {
      // AB: Don't show/load the typing animation below current question while additional calendar dates are being fetched in Calendar component
    } else {
      if (value.status === "typing" && !this.ignoreTyping) {
        this.typingIndicator = component = new Block({
          data: value,
        });
      }
    }

    return component;
  }

  clearAfterId(identifier, parentEl, keepCurrentComponent) {
    let id = identifier;
    if (identifier.endsWith("/error")) {
      id = identifier.split("/error")[0];
    }

    if (!this.contentHash[id]) return;

    let index = this.contentHash[id][0];
    const newHash = {};

    if (keepCurrentComponent) {
      // Don't remove the current component from the hash and move index to the next question
      index++;
    } else {
      delete this.contentHash[id];
    }

    if (parentEl) {
      this.elContainer.removeELM(parentEl);
    }

    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index) {
        this.elContainer.removeELM(ch[1]);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;
  }

  showMore(elm) {
    const height = getWindowHeight();
    const bound = elm.getBoundingClientRect();

    if (bound.height > height) {
      ScrollNotification.attachElement(elm);

      if (window.navigator.userAgent.indexOf('MSIE') !== -1 || window.navigator.userAgent.indexOf('Trident/') > -1) {
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('scroll', true, false, window, 0);
        window.dispatchEvent(evt);
      } else {
        window.dispatchEvent(new Event("scroll"));
      }
    }
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }
}

module.exports = Bot;
